export default __webpack_public_path__ + "static/media/footer-img.fa1ab603.png";